import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { requestResponseHandler } from '../../base/decorators';
import { getFormDataWithParams } from '../../base/utils';
import { networkRequest } from '@tencent/ark-request';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
import qs from 'qs';
import * as CgiPath from './cgi-path';
/**
 * 更新标题CGI后台约定的参数值:版本号
 */
export var UpdateTitleVersion = 2;
var DocMetaRepository = /** @class */ (function () {
    function DocMetaRepository() {
    }
    DocMetaRepository.prototype.updateTitle = function (title, autoChange, domainId, padId) {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, request;
            return __generator(this, function (_a) {
                paramObj = {
                    pad_id: padId,
                    domain_id: domainId,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    version: UpdateTitleVersion,
                    auto_change: autoChange ? 1 : 0, // 与后台约定1为自动修改标题，否则表示不自动修改标题
                    title: encodeURIComponent(title),
                };
                request = addURLParameters(CgiPath.DOC_CHANGE_TITLE, paramObj);
                return [2 /*return*/, networkRequest.post(request)];
            });
        });
    };
    /**
     * 获取当前收藏状态
     */
    DocMetaRepository.prototype.fetchCollectedState = function (domainId, padId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    domain_id: domainId,
                    pad_id: padId,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    t: Date.now(), // 防止IE缓存，加时间戳
                };
                url = addURLParameters(CgiPath.GET_DOC_COLLECT_STATE, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    /**
     * 设置收藏/取消收藏
     */
    DocMetaRepository.prototype.changeCollectedState = function (domainId, padId, collect) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, config;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    domain_id: domainId,
                    pad_id: padId,
                    is_cancel: collect ? 0 : 1,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                });
                config = { contentType: 'application/x-www-form-urlencoded' };
                return [2 /*return*/, networkRequest.post(CgiPath.DOC_COLLECT, formData, config)];
            });
        });
    };
    /**
     * 获取当前文档元数据
     */
    DocMetaRepository.prototype.fetchDocInfo = function (domainId, padId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    domainId: domainId,
                    localPadId: padId,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(CgiPath.DOC_INFO, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    DocMetaRepository.prototype.fetchDocMetaInfoData = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    id: docId,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(CgiPath.DOC_META_INFO, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    DocMetaRepository.prototype.fetchFileInfo = function (docId, addRecent) {
        return __awaiter(this, void 0, void 0, function () {
            var queryStringParams, queryString, requestBody;
            return __generator(this, function (_a) {
                queryStringParams = { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) };
                queryString = qs.stringify(queryStringParams);
                requestBody = { file_id: docId, add_recent: addRecent };
                return [2 /*return*/, networkRequest.post("".concat(CgiPath.FILE_INFO, "?").concat(queryString), requestBody)];
            });
        });
    };
    DocMetaRepository.prototype.updateOfficialAuthInfo = function (padId, padType) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    id: padId,
                    type: padType,
                    command: 1,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(CgiPath.DOC_PRELOAD, params);
                return [2 /*return*/, networkRequest.get(url)];
            });
        });
    };
    DocMetaRepository.prototype.getOwnerVipInfo = function (padId, getAll) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    file_id: padId,
                    get_all: getAll,
                };
                return [2 /*return*/, networkRequest.post(CgiPath.DOC_OWNER_VIP_LEVEL, params)];
            });
        });
    };
    __decorate([
        requestResponseHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Boolean]),
        __metadata("design:returntype", Promise)
    ], DocMetaRepository.prototype, "getOwnerVipInfo", null);
    return DocMetaRepository;
}());
export default DocMetaRepository;
